import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DocumentAutomations  {
    _originalTypeClassName = "zERP.BO.DocumentAutomations";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DocumentAutomations.translate = translateService;
}
this.DocumentAutomationsKey = null;
this._key = this.DocumentAutomationsKey = 0; 
}

static translate: TranslateService;
_key: any;
private _DocumentAutomationsKey:any;
get DocumentAutomationsKey(): any {
    return this._DocumentAutomationsKey;
  }
set DocumentAutomationsKey(value: any) {
    this._DocumentAutomationsKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.DocumentAutomationsKey == null || $this.DocumentAutomationsKey == 0;
            }


}